import styled from "styled-components";
import './style.css'
// import { ImCheckboxChecked } from "react-icons/im"; // Não utilizado atualmente
// import { FaMinus } from "react-icons/fa"; // Não utilizado atualmente
// import { FaPlus } from "react-icons/fa6"; // Não utilizado atualmente
import { useState } from "react";
import InputMoney from "../../pages/ListItem/InputMoney";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import { getCurrencySymbol, formatPriceWithSymbol } from '../../utils/currency';


const DivBGtransparent = styled.div`
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  display: ${({ showModalPaymentCash }) => (showModalPaymentCash ? 'flex' : 'none')};
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  align-items: center;
  justify-content: center;
  opacity: ${({ showModalPaymentCash }) => (showModalPaymentCash ? '1' : '0')};
  transition: opacity 0.25s ease;
  animation: ${({ showModalPaymentCash }) => (showModalPaymentCash ? 'modalFadeIn 0.25s ease forwards' : 'none')};

  @keyframes modalFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const DivContainer = styled.div`
    z-index: 10000;
    position: relative;
    width: 90%;
    max-width: 480px;
    background-color: #fff;
    border-radius: 16px;
    padding: 20px 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    animation: modalSlideUp 0.3s ease;

    @keyframes modalSlideUp {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }

`;

const ModalPaymentCash = ({
    setItensCarrinho,
    itensCarrinho,
    selectedItemId,
    showModalPaymentCash,
    setShowModalPaymentCash,
    valorTroco,
    setValorTroco,
    setPaymentType,
    valorTotalPedido,
}) => {
    const { t } = useTranslation('cardapio');
    // const navigate = useNavigate(); // Não utilizado atualmente
    // const { nomeEmpresaForUrl, idEmpresa } = useParams(); // Não utilizado atualmente
    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(nomeEmpresaForUrl, idEmpresa);
    const valorTotalPedidoFloat = typeof valorTotalPedido === 'number' ? valorTotalPedido : parseFloat(String(valorTotalPedido).replace(',', '.')) || 0;

    const closeModalWithChange = () => {
        if (valorTroco <= valorTotalPedidoFloat && valorTroco > 0){
            toast(t('modal.cash.changeMustBeGreater'), {autoClose:5000,type: "error"})
        }
        if(valorTroco===0){
            toast(t('modal.cash.enterChangeAmount'), {autoClose:5000,type: "error"})
        } 
        if(valorTroco > 0 && valorTroco > valorTotalPedidoFloat){
            setValorTroco(valorTroco)
            setShowModalPaymentCash(!showModalPaymentCash);
            setPaymentType("Dinheiro") 
        }
    }

    const closeModal = () => {        
        setValorTroco(0)
        setShowModalPaymentCash(!showModalPaymentCash);
        setPaymentType("Dinheiro")
    }

    const [isFocused, setIsFocused] = useState(false);
    const handleFocus = () => {
        setIsFocused(true);
    };
    
    const handleBlur = () => {
        setIsFocused(false);
    };

    const onChange = (event, nameObject, isNumber) => {
        setValorTroco(isNumber ? Number(event.target.value) : event.target.value);
        //formik.setFieldValue("preco", isNumber ? Number(event.target.value) : event.target.value );
    };

    return (
        <DivBGtransparent showModalPaymentCash={showModalPaymentCash}>
            <DivContainer>
               
                <div className="divTitleItemAdicionado">
                    <span className="divTitleItemAdicionadoSpan">{t('modal.cash.needChange')}</span> 
                </div>

                <div className="qtdBoxContainer">
                    <div>
                        <span>{t('modal.cash.orderTotal')}</span>
                        <span style={{fontWeight:600, marginLeft:5}}>{formatPriceWithSymbol(valorTotalPedido)}</span>
                    </div>                 
                </div>

                <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                    <label style={{fontWeight:600}}>{t('modal.cash.changeFor')}</label>
                    <div style={{padding:"0px 20px 0px 20px"}}>
                    <InputMoney
                    onChange={(event) => onChange(event, 'price', true)}
                    value={valorTroco}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    //margin="0px 0px 16px 0px"                    
                    style={{
                    outline: isFocused ? '2px solid #4070f4' : 'none',
                    borderRadius:10,
                    margin: '0.6rem 0 0.2rem 0',
                    //padding:'0px 20px 0px 20px'
                    }}
                    className="inputPersonalizedTroco"
                    placeholder={t('modal.cash.changePlaceholder')}
                    />  
                    </div>
                </div>

                <div className="divBtnContinueCart">
                    <button className="buttonContinue" onClick={()=> closeModal()}>{t('modal.cash.noChange')}</button>
                    <div style={{width:'100%'}}>
                        <button className="buttonCart" onClick={() => closeModalWithChange()}>{t('modal.cash.confirm')}</button>
                    </div>
                </div>

            </DivContainer>
        </DivBGtransparent>
    );
}

export default ModalPaymentCash